import { Toolbox } from '~/plugins/toolbox/shared'
import {
  UIChatItem,
  UIChatMessageToken,
  UIChatMessageTokenType,
} from '../../types'

export const parseMessageContent = (item: UIChatItem) => {
  let content = item?.content ?? ''

  const tokenTypes: UIChatMessageTokenType[] = [
    'TASK',
    'POST',
    'FILE',
    'TICKET',
    'EMAIL',
    'CALENDAR_EVENT',
  ]

  const tokens: UIChatMessageToken[] = []

  tokenTypes.forEach(type => {
    const { ids, updatedContent } = parseTokens(content, type)
    if (ids?.length > 0) {
      tokens.push(...ids.map(id => ({ type, id })))
      content = updatedContent
    }
  })

  const tokensUnique = Toolbox.UtilityItems.makeUnique(tokens, 'id')

  return {
    content: content.trim(),
    tokens: tokensUnique,
  }
}

const parseTokens = (content: string, type: string) => {
  const regex = new RegExp(`<${type}:([^>]+)>`, 'g')
  const matches = [...content.matchAll(regex)]
  const ids = matches.map(match => match[1])

  const updatedContent = content.replace(regex, '').trim()

  return { ids, updatedContent }
}
